import { cx } from '@linaria/core';
import { useRef, useId, useEffect, useCallback } from 'react';
import { useUserIdentityState } from '@provider/user-identity';
import { TextInput, Richtext } from '@ui/kit';
import { isTouchDevice } from '@utils/common';
import { useComponentInteractions, useComponentEntry } from '@utils/component-framework';
import { wrapper, heading, singleLineInput } from './atom.input.style.js';
import { richtextStyles } from './shared.richtext.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useUpdateIGuideEntryInputMutation } from '../state/mutation.update-entry-value.js';
import { useHTMLContent } from '../ast/util.print-html.js';

function TaskInput(props) {
  const interactions = useComponentInteractions();
  const updateEntryMutation = useUpdateIGuideEntryInputMutation(props.entryKey);
  const heading$1 = useHTMLContent(props.input.text);
  const user = useUserIdentityState(state => state.user);
  const editorRef = useRef(undefined);
  const inputAriaId = `i-guide-input--${props.taskId}${props.input.id}-${useId()}`;
  const value = useComponentEntry(props.entryKey, {
    select: entry => entry?.data.answers[props.taskId]?.[props.input.id] ?? ""
  });

  // Ensure that Froala is properly reset in case the entire component is reset.
  useEffect(() => {
    const editor = editorRef.current;
    if (!editor) {
      return;
    }
    editor.html.set(value.data || props.input.predefinedAnswer || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.entryKey]);
  const onRichtextEditorInitialized = editor => {
    editorRef.current = editor;
  };
  const ownsEntry = useComponentEntry(props.entryKey, {
    select: entry => entry?.envelope.userID === user?.id
  });
  const readOnlyContent = useHTMLContent(value.data ?? "", {
    disabled: !user || ownsEntry.data || props.input.type === "input"
  });
  const handleChange = useCallback(value => {
    updateEntryMutation(props.taskId, props.input.id, value);
  }, [props.input.id, props.taskId, updateEntryMutation]);
  const onKeyDown = useCallback(evt => {
    switch (evt.key) {
      case "Enter":
        if (isTouchDevice()) {
          evt.currentTarget.blur();
        }
        break;
      case "Shift":
      case "Tab":
        break;
      default:
        interactions.onActivate();
    }
  }, [interactions]);
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    children: [!!heading$1?.length && /*#__PURE__*/jsx("label", {
      htmlFor: inputAriaId,
      className: cx(heading, richtextStyles),
      children: heading$1
    }), props.input.type === "input" && /*#__PURE__*/jsx(TextInput, {
      id: inputAriaId,
      className: singleLineInput,
      onClick: interactions.onActivate,
      onKeyDown: onKeyDown,
      placeholder: "Skriv her",
      value: value.data || props.input.predefinedAnswer || "",
      onChange: handleChange,
      readOnly: !ownsEntry.data
    }), props.input.type === "text" &&
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    jsx("div", {
      onClick: interactions.onActivate,
      onKeyDown: onKeyDown,
      children: /*#__PURE__*/jsx(Richtext, {
        id: inputAriaId,
        initialValue: value.data || props.input.predefinedAnswer || "",
        toolbarButtons: props.settings.formatting ?? undefined,
        placeholderText: "Skriv dit svar her...",
        onChange: handleChange,
        onInitialized: onRichtextEditorInitialized,
        readOnlyContent: readOnlyContent
      })
    })]
  });
}

export { TaskInput };
//# sourceMappingURL=atom.input.js.map
